import React from 'react'
import { ModalV2 } from "components/Modal/ModalV2";
import { useForm } from "hooks/useForm";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FormImei } from "./FormImei";
import { sendConfigUnitV2 } from "redux/actions/unitsSection/unitsAction";

export const ImeiModal = ({
    edit,
    setEdit,
    imeiCode = "",
    unitId = ""
}) => {
    const dispatch = useDispatch()
    const { isLoadingComp } = useSelector(({ search }) => search);

    const {
        inputValues: { imei },
        onChange,
        fieldErrors,
        setValues
    } = useForm({ imei: "" });


    const handleSubmit = () => {
        const trimmed = imei?.trim();
        dispatch(sendConfigUnitV2(
            unitId,
            { imei: trimmed || null },
            true,
            false,
            "",
            setEdit
        ));
    };

    useEffect(() => {
        setValues({ imei: imeiCode || "" })
    }, [imeiCode])
    return (
        <ModalV2
            title="Editar IMEI de Unidad"
            open={edit}
            onClose={setEdit}
            justConfirm
            isLoading={isLoadingComp?.loadingConfigEdit}
            onSubmit={handleSubmit}
        >
            <FormImei
                onChange={onChange}
                imei={imei}
                loading={isLoadingComp?.loadingConfigEdit}
            />
        </ModalV2>
    )
}